module.exports = __webpack_public_path__ + "static/img/b71a6704e1c4e9426ab4a760f0205488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_44.jpg
// module id = sz+m
// module chunks = 1